<template>
  <div class="container py-4">
    <h3 class="mb-4">Messaging Events Settings</h3>

    <table class="table table-bordered table-striped">
      <thead>
        <tr>
          <th>#</th>
          <th>Event Name</th>
          <th>Description</th>
          <th>SMS Enabled</th>
          <th>Email Enabled</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(setting, index) in settings" :key="setting.id">
          <td>{{ index + 1 }}</td>
          <td>{{ setting.event_name }}</td>
          <td>{{ setting.description }}</td>
          <td>
            <input
              type="checkbox"
              :checked="statuses[setting.id]?.sms_enabled"
              @change="
                toggleSetting(setting.id, 'sms_enabled', $event.target.checked)
              "
            />
          </td>
          <td>
            <input
              type="checkbox"
              :checked="statuses[setting.id]?.email_enabled"
              @change="
                toggleSetting(
                  setting.id,
                  'email_enabled',
                  $event.target.checked
                )
              "
            />
          </td>
        </tr>
      </tbody>
    </table>

    <div v-if="loading" class="text-center mt-3">Loading...</div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import { reactive } from "vue";

export default {
  name: "MessagingSettings",
  data() {
    return {
      settings: [],
      statuses: reactive({}), // separate reactive object for checkboxes
      loading: false,
    };
  },
  methods: {
    async fetchSettings() {
      try {
        this.loading = true;
        const response = await generalApiRequest(
          "messaging-settings/list",
          "GET",
          {},
          1
        );
        this.settings = response;

        // initialize reactive checkbox statuses
        this.settings.forEach((s) => {
          this.statuses[s.id] = {
            sms_enabled: !!s.sms_enabled,
            email_enabled: !!s.email_enabled,
          };
        });
      } catch (error) {
        console.error("Failed to fetch settings:", error);
      } finally {
        this.loading = false;
      }
    },

    async toggleSetting(settingId, field, value) {
      const oldValue = this.statuses[settingId][field];
      this.statuses[settingId][field] = value; // optimistic update

      try {
        const url = `messaging-settings/${settingId}/update-status`;
        const payload = { [field]: value };
        console.log(payload);

        const response = await generalApiRequest(url, "POST", payload, 1);

        // safely update from server
        this.statuses[settingId][field] = response.data[field];
      } catch (error) {
        console.error("Failed to update setting:", error);
        this.statuses[settingId][field] = oldValue; // revert
      }
    },
  },
  mounted() {
    this.fetchSettings();
  },
};
</script>
